/* tslint:disable */
/* eslint-disable */
import { globalMediaEventEmitter } from '@atlaskit/media-client';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import { fg } from '@confluence/feature-gating';

const requests: Map<string, Promise<any>> = new Map();
const setCacheWithTimeout = (fileId, req): void =>
	requests.set(fileId, req) && void setTimeout(() => requests.delete(fileId), 3000);

const isDownloadEvent = (options): boolean =>
	fg('confluence_publish_attachment_audit_log_event') && options.viewingLevel === 'download';

const getNotifyRequestBody = (options) => {
	if (isDownloadEvent(options)) {
		return {
			attachmentDownloaded: {
				fileStoreId: options.fileId,
			},
		};
	}
	return {
		attachmentViewed: {
			fileStoreId: options.fileId,
		},
	};
};

const getTrackEventPayload = (options, contentType) => {
	const action = isDownloadEvent(options) ? 'downloaded' : 'viewed';
	return {
		source: 'ui',
		actionSubject: 'attachment',
		action,
		name: `attachment ${action}`,
		attributes: {
			activationId: options.fileId,
			pageType: contentType,
		},
	};
};

const globalMediaViewedListener = (options, contentType) => {
	// To avoid case when user opens media-picker (and we don't want to call BE API after that)
	if (!options.isUserCollection) {
		// Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
		// multiple times for a single `media-viewed` event. For this reason we return a cached
		// request promise if one exists
		const priorRequestForTheSameFileID = requests.get(options?.fileId);

		return (
			priorRequestForTheSameFileID ||
			(() => {
				const mediaViewedReq = fg('confluence_event_notifier_deprecation')
					? Promise.resolve({})
					: fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
							method: 'POST',
							body: JSON.stringify(getNotifyRequestBody(options)),
							headers: {
								'Content-Type': 'application/json',
							},
						});

				if (fg('confluence_event_notifier_updates')) {
					void getAnalyticsWebClient().then((analyticsWebClient) => {
						analyticsWebClient.sendTrackEvent(getTrackEventPayload(options, contentType));
					});
				}

				setCacheWithTimeout(options.fileId, mediaViewedReq);

				return mediaViewedReq;
			})()
		);
	}
};

let mediaViewedListenerRegistered = false;
// make sure currentListener is a stable reference so it can be removed by .off event handler
let currentListener: ((options: any) => void) | null = null;

export const registerGlobalMediaViewedListener = ({
	contentType,
}: {
	contentType?: string;
}): void => {
	if (!mediaViewedListenerRegistered) {
		currentListener = (options) => {
			globalMediaViewedListener(options, contentType);
		};
		globalMediaEventEmitter.on('media-viewed', currentListener);
		mediaViewedListenerRegistered = true;
	}
};

export const removeGlobalMediaViewedListener = (): void => {
	if (currentListener) {
		globalMediaEventEmitter.off('media-viewed', currentListener);
		currentListener = null;
		mediaViewedListenerRegistered = false;
	}
};
